import React, { useState,useEffect} from "react";
import "../../../../../src/styles/userManagement.css";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import InitiateAssessment from "../OnSiteCreate";
import PropTypes from "prop-types";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
import { Loading } from '@appkit4/react-components/loading';
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

export default function AllSelfAssessments(props) {
  const { AssessmentData, getSelfAssessmentsforAssessor } = props
  const [editScreen, setEditScreen] = useState(false);
  const [deletemodalVisible, setDeletemodalVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [wpDetails, setWpDetails] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [wpID, setWpID] = useState(null)
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getAssessmentByWPID } = useHttp();
  const { sendRequest: deleteAssessmentPlanByAssessor } = useHttp();
  const [vendorassessmentrequestid, setVendorAssessmentRequestID] = useState();
  const delete_click=async (ID1, ID2,wpID) => {
   const email=sessionStorage.getItem("email");

    let data = { vendorassessmentrequestid: Number(ID1), userId: Number(ID2),wpID:Number(wpID),email:email, assessmentType: "Self"};
    try {
      deleteAssessmentPlanByAssessor(APIService.deleteAssessmentPlanByAssessor(data), (result) => {
        if (result.CODE) {
          setVisible(false);
        setDeletemodalVisible(false);
        displayToastMessage(result.MSG, "success");
        handleBack();
        } else {
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const getAssessmentWPID = async (ID) => {
    getAssessmentByWPID(APIService.getAssessmentByWPID(ID), (res) => {
      if(res){
         /*work programme questionaire remove by other profile then assessor can't see those ans  */
         const filteredData = JSON.parse( res?.MSG[0]?.category_data).filter(
          (item) => item.questionIDToggle ===true
        );
         setCategoryData(filteredData);
        setWpDetails(res.MSG);
        setEditScreen(true);
        setLoader(false);
      }
    });
  };

  const handleBack = () => {
    setEditScreen(false);
    setTableData(AssessmentData);
    setFilter(AssessmentData);
    let totalPageLength = Math.ceil((AssessmentData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
    getSelfAssessmentsforAssessor();
    setSearch("");
  };

  const handleCancel = (e) => {
    setVisible(false);
    setDeletemodalVisible(false);
    setSearch("");
  };

  function formatDate(date) {
    let newDate = ""
    if (date && date !== null) {
      let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    newDate = [day, month, year].join('-')
    }
    return newDate
  }

  useEffect(() => {
    // setEditScreen(false);
    setTableData(AssessmentData);
    setFilter(AssessmentData);
    let totalPageLength = Math.ceil((AssessmentData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [AssessmentData]);

  useEffect(() => {
    const result = tableData?.filter((assessmentList) => {
      return assessmentList?.vendor_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [search]);

const sortFuncForOrder1 = (a, b) => {
  const firstOrderId = (a.vendor_name).charAt(1);
  const secondOrderId = (b.vendor_name).charAt(1);
  return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.vendor_name).charAt(1);
  const secondOrderId = (b.vendor_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}

const renderEndDate = (row) => {
  return formatDate(row?.end_assessment_date);
}

const renderNextPlannedDate = (row) => {
  return formatDate(row?.next_planned_date);
}

const renderActionCell = (row) => {
  return (
    <>
      <span className=" Appkit4-icon icon-edit-fill pointer action-icon" title="Initiate" onClick={() => handleEditButton(row)}></span>&nbsp;
      <span className=" Appkit4-icon icon-delete-fill pointer action-icon" title="Delete" onClick={() => handleDeleteButton(row)}></span>
    </>
  )
}

  const handleEditButton = (row) => {
    if(row?.workprogram_id){
      setLoader(true);
      getAssessmentWPID(row?.workprogram_id);
      setWpID(row?.workprogram_id);
      setSearch("");
    }
  }

  const handleDeleteButton = (row) => {
    if(row?.vendorassessmentrequestid && row?.workprogram_id){
      setVendorAssessmentRequestID(row?.vendorassessmentrequestid);
      setWpID(row?.workprogram_id)
    }
    setVisible(true);
    setDeletemodalVisible(true);
    setSearch("");
  }

  return (
    <div className="App">
      <div className="user-management-container">
       
              <div>
                {editScreen ?(<InitiateAssessment
                    handleBack={handleBack}
                    Assessmentdata={wpDetails}
                    categoryData={categoryData}
                    wpID = {wpID}
                    getSelfAssessmentsforAssessor={getSelfAssessmentsforAssessor}
                  />):(
                    <div className="col-lg-12 mt-3 pl-1">
                      {tableData.length > 0 ? (
                        <Input
                        type="text"
                        title= "Search Third Party Name"
                        value={search}
                        className="ap-field-wrapper-tableSearch"
                        onChange={(e) => setSearch(e)}
                      /> 
                      ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "" : "biaTableBU"}>
                    <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2} className={filter.length === 0 ? "" : "oneSeventy"}>Third Party Name</Column>
                    <Column field="status" sortKey={filter.length > 0 ? "status" : ""}>Status</Column>
                    <Column field="criticality" sortKey={filter.length > 0 ? "criticality" : ""}>Criticality</Column>
                    <Column field="end_assessment_date" sortKey={filter.length > 0 ? "last_assessment_date" : ""} renderCell={renderEndDate} className={filter.length === 0 ? "" : "oneNinty"}>Assessment End Date</Column>
                    <Column field="vendorpointof_contact_email" sortKey={filter.length > 0 ? "vendorpointof_contact_email" : ""} className={filter.length === 0 ? "" : "oneSeventy"}>Third Party Email</Column>
                    <Column field="category" sortKey={filter.length > 0 ? "category" : ""} className={filter.length === 0 ? "" : "oneFifty"}>Category</Column>
                    <Column field="vendor_review_status" sortKey={filter.length > 0 ? "vendor_review_status" : ""} className={filter.length === 0 ? "" : "oneFifty"}>Review Status</Column>
                    <Column field="workprogram_id"
                    className={filter.length === 0 ? "" : "nintyFive"}
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
                )}
                
              </div>
            
      </div>
      {
                loader &&(
                    <div className="row" id="preloader">
                    <div className="col-12 col-lg-12 loader-margin text-center loadingCss">
                      <div className="a-loading a-primary a-m-10 loadingText" role="status">
                       Loading...
                       <Loading loadingType='circular' indeterminate={true} compact={false}></Loading>
                      </div>
                    </div>
                  </div>
                  )
            }
      <Modal
        className="baseline-modal-showcase"
        visible={deletemodalVisible}
        onCancel={handleCancel}
        bodyStyle={{ maxHeight: "280px" }}
        footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
        modalStyle={{ width: "49.75rem" ,maxHeight:"fit-content" }}
      >
          <div className="modal-title">
          Are you sure you want to delete?
          </div>
        <ModalFooter>
          <button
            type="button"
            className="cancel-button"
            onClick={handleCancel}
          >
            No
          </button>

          <button
            type="submit"
            className="save-button m-l-2"
            onClick={() =>
              delete_click(
                vendorassessmentrequestid,
                Number(sessionStorage.getItem("userId")),
                wpID
              )
            }
          >
            Yes
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

AllSelfAssessments.propTypes = {
  AssessmentData: PropTypes.any, 
  getSelfAssessmentsforAssessor: PropTypes.any
}